import { apiMipe, api } from '@/core/api/';
import applicationTypes from '@/utils/constants/applicationTypes';

export const getStudentSchool = async (studentSieId, academicYearId) => {
  return await apiMipe.get(
    `api/student/getstudentschool/${studentSieId}/${academicYearId}`
  );
};

export const getReferrals = async (params) => {
  return await apiMipe.get(`api/studentreferrals/thrpyreferrals`, {
    params: { ...params, applicationType: applicationTypes.PortalProveedor },
  });
};

export const getLatestSignedPeipReport = async (studentSieId) => {
  return await api.get(
    `api/report/latestsignedpeipreport?studentSieId=${studentSieId}`
  );
};

export const getReferralSheet = async (studentServiceId) => {
  return await apiMipe.get(
    `api/report/studentservice/referralreport/${studentServiceId}`
  );
};

export const getReferralsheetevaluation = async (studentReferralId) => {
  return await apiMipe.get(
    `api/studentevaluation/referralsheetevaluation/${studentReferralId}`
  );
};

export const replaceSheetEvaluation = async (model, file) => {
  const formData = new FormData();
  formData.append('File', file);
  return await apiMipe.post(
    `/api/studentevaluation/${model.studentEvaluationId}/replacedocument?documentTypeId=${model.documentType}`,
    formData
  );
};

export const getReferralDetails = async (admisionid) => {
  return await apiMipe.get(
    `api/studentreferrals/getthrpyreferraldetails/${admisionid}`
  );
};

export const saveDenegateReferral = async (model) => {
  return await apiMipe.post(`api/studentreferrals/savedenegatereferral`, model);
};

export const getRejectionReasonsByType = async (typeId) => {
  return await apiMipe.get(
    `api/studentreferrals/getthrpyrejectionreasonsbytype/${typeId}`
  );
};

export const saveRejectionLinkAdmission = async (model) => {
  return await apiMipe.post(
    `api/studentreferrals/saveRejectionlinkadmission`,
    model
  );
};

export const getProviderMunicipalities = async (admissionId) => {
  return await apiMipe.get(
    `api/studentreferrals/admission/${admissionId}/municipalities`
  );
};

export const getSchoolByMunicipality = async (admissionId, municipalityId) => {
  return await apiMipe.get(
    `api/studentreferrals/admission/${admissionId}/schoolsBy`,
    { params: { municipalityId } }
  );
};

export const getProviderDetail = async (admissionId) => {
  return await apiMipe.get(
    `api/studentreferrals/admission/${admissionId}/detail`
  );
};

export const getProviderReasons = async (serviceProviderSelectionOptionId) => {
  return await apiMipe.get(
    `api/studentreferrals/admission/providerrejectionreasons`,
    {
      params: {
        optionId: serviceProviderSelectionOptionId,
      },
    }
  );
};

export const getSchoolByAdmissionId = async (admissionId) => {
  return await apiMipe.get(
    `api/studentreferrals/admission/${admissionId}/schools`
  );
};

export const getAdmissionRejectionHistory = async (
  admissionId,
  pageNumber,
  pageSize
) => {
  return await apiMipe.get(
    `api/studentreferrals/admissionrejectionhistory/${admissionId}`,
    {
      params: {
        pageNumber: pageNumber,
        pageSize: pageSize,
      },
    }
  );
};

// Needs to be updated to PUT in the backend, currently is a get (facepalm)
export const updateBillingCenter = async (params) => {
  return await apiMipe.get(`api/studentreferrals/updatebillingCenter`, {
    params,
  });
};

export const getAllBillingCenters = async () => {
  return await apiMipe.get(`api/code/servicecenter`);
};

export const getAdmissionStatus = async () => {
  return await apiMipe.get(`api/thrpyadmission/getadmissionstatus`);
};

export const getAdmissionStatusReasons = async (statusId) => {
  return await apiMipe.get(`api/thrpyadmission/admissionstatusreason`, {
    params: { admissionStatusId: statusId },
  });
};

export const getAdmissionReferralTypes = async () => {
  return await apiMipe.get(`api/thrpyadmission/getadmissionreferraltypes`);
};

export const getServiceModalityTypes = async () => {
  return await apiMipe.get(`api/thrpyadmission/servicemodalitytypes`);
};

export const createProvisionalRemedy = async (
  studentSieId,
  disciplineTypeId
) => {
  return await apiMipe.get(
    `/api/studentreferrals/checkprovisionalremedyrequest/${studentSieId}/${disciplineTypeId}`
  );
};

export const downloadProvissionalRemedyRequestReport = async (
  requestNumber
) => {
  return await apiMipe.get(
    `/api/studentevaluation/requestreportdownload?requestNumber=${requestNumber}`
  );
};

export const approvalLetterDownload = async (requestServiceId) => {
  return await apiMipe.get(
    `/api/studentevaluation/disciplineapprovalletterdownload?RequestServiceId=${requestServiceId}`
  );
};
/**
 *
 * @params { admissionId, requestId, disciplineTypeId } model
 */
export const approveProvisionalRemedy = async (model) => {
  return await apiMipe.post(
    `/api/studentreferrals/approveprovisionalremedyrequest/${model.admissionId}/${model.requestId}/${model.disciplineTypeId}`
  );
};

export const getDocumentsByStudentServiceId = async (studentServiceId) => {
  return await apiMipe.get(
    `/api/thrpyadmission/GetDocumentsByStudentServiceId/${studentServiceId}`
  );
};

export const getSignedDocumentByStudentServiceId = async (studentServiceId) => {
  return await apiMipe.get(
    `/api/thrpyadmission/GetSignedDocumentByStudentServiceId/${studentServiceId}`
  );
};

export const deleteDocumentByDocumentId = async (
  documentId,
  referralItemAttachmentId = null
) => {
  return await apiMipe.delete(
    `/api/thrpyadmission/DeleteDocumentAdmissionNote`,
    {
      params: {
        documentId,
        referralItemAttachmentId,
      },
    }
  );
};

export const getDocumentsByStudentServiceIdAndAdmissionId = async (
  studentServiceId,
  admissionId
) => {
  return await apiMipe.get(
    '/api/thrpyadmission/DocumentsByStudentServiceAdmission/',
    {
      params: {
        studentServiceId,
        admissionId,
      },
    }
  );
};

export const getValidDocumentTypes = async (
  studentServiceId,
  academicYearId
) => {
  return await apiMipe.get('/api/studentreferrals/validdocumenttypes', {
    params: {
      studentServiceId,
      academicYearId,
    },
  });
};

export const therapyDocTypeOther = async (academicYearId) => {
  return await apiMipe.get('/api/studentreferrals/ThrpyDocTypeOther', {
    params: {
      academicYearId,
    },
  });
};

export const downloadDocumentForThrerapyReferral = async (attachmentId) => {
  return await apiMipe.get(
    `/api/documents/downloadtherapyreferral/${attachmentId}`
  );
};

export const downloadDocumentForRP = async (attachmentId) => {
  return await apiMipe.get(`/api/documents/downloadrp/${attachmentId}`, {
    responseType: 'blob',
  });
};

export const saveInterventionPlanDocument = async (formData) => {
  return await apiMipe.post(
    `api/studentreferrals/interventionplan/savedocument/`,
    formData
  );
};

export const updateReferralItemAttachment = async (formData) => {
  return await apiMipe.put(
    `api/thrpyadmission/updatethrpyreferralitemattachment/`,
    formData
  );
};

export const saveThrpyReferralItemAttachment = async (formData) => {
  return await apiMipe.post(
    `api/thrpyadmission/savethrpyreferralitemattachment`,
    formData
  );
};

export const getVisitHistory = (admissionId, academicYearId = null) =>
  apiMipe.get(`/api/thrpyadmission/GetAdmissionVisitDetail/${admissionId}`, {
    params: {
      academicYearId: academicYearId,
    },
  });

export const getReferralHistory = (admissionId) =>
  apiMipe.get(`/api/thrpyadmission/GetLastReferralHistory/${admissionId}`);

export const getSpecialistsForAssignment = (
  admissionId,
  locationFiscalYearId,
  studentSieId,
  specialistId,
  isAdmission = true
) => {
  return apiMipe.get(
    `api/studentreferrals/getadmissionspecialistsforassignment?locationFiscalYearId=${locationFiscalYearId ??
      0}&admissionId=${admissionId}&studentSieId=${studentSieId}&boundSpecialistId=${specialistId}&isAdmission=${isAdmission}`
  );
};

export const saveAssignment = async (data) => {
  return await apiMipe.post('api/studentreferrals/saveassignment', data);
};

export const getAdmissionDropReasons = async (
  admissionDropTypeId,
  admissionStatusId
) => {
  return await apiMipe.get(
    `/api/thrpyadmission/admissiondropreasons/${admissionDropTypeId}/${admissionStatusId}`
  );
};

export const getAdmissionManagementMunicipality = async (
  fiscalYearId,
  providerId
) => {
  return await apiMipe.get(
    `/api/thrpyadmission/admissionmanagementmunicipality/${fiscalYearId}/?providerId=${providerId}`
  );
};

export const getAdmissionManagementLocation = async (
  fiscalYearId,
  providerId,
  municipalityId
) => {
  return await apiMipe.get(
    `/api/thrpyadmission/admissionmanagementlocation/${fiscalYearId}/${providerId}/${municipalityId}`
  );
};

export const getAdmissionManagementSpecialist = async (
  serviceLocationId,
  disciplineId,
  admissionId
) => {
  return await apiMipe.get(
    `/api/thrpyadmission/admissionmanagementspecialist/${serviceLocationId}/${disciplineId}/${admissionId}`
  );
};

export const getAdmission = async (admissionId) => {
  return await apiMipe.get(`api/thrpyadmission/admission/${admissionId}`);
};

export const getAdmissionManagementRequest = (admissionId) => {
  return apiMipe.get(
    `api/thrpyadmission/admissionmanagement/${admissionId}/request`
  );
};

export const admissionManagement = (management) => {
  return apiMipe.post(`api/thrpyadmission/admissionmanagement`, management, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};
export const confirmAdmission = async (data) => {
  return await apiMipe.post('api/studentreferrals/confirmadmission', data);
};

export const getStudentServiceOffering = (params) => {
  return apiMipe.get(`api/studentreferrals/serviceOffering`, { params });
};
export const savePartialAdmission = async (data) => {
  return await apiMipe.post('api/studentreferrals/savepartialdmission', data);
};
export const confirmPartialAdmission = async (data) => {
  return await apiMipe.post(
    'api/studentreferrals/confirmpartialdmission',
    data
  );
};
export const coordinateServiceAdmission = async (data) => {
  return await apiMipe.post(
    'api/studentreferrals/coordinateserviceadmission',
    data
  );
};
export const updateAdmission = async (data) => {
  return await apiMipe.post('api/studentreferrals/updateadmission', data);
};

export const getAdmissionStatusDelayReason = async () => {
  return await apiMipe.get('api/studentreferrals/admissionstatusdelayreason');
};

export const getAdmissionInfo = (admissionId) => {
  return apiMipe.get(`api/studentreferrals/infoforadmission/${admissionId}`);
};

export const getAdmissionLocations = (admissionId, municipalityId) => {
  return apiMipe.get(
    `api/studentreferrals/locations/${admissionId}/${municipalityId}`
  );
};

export const getAdmissionCenters = (
  admissionId,
  municipalityId,
  locationTypeId
) => {
  return apiMipe.get(
    `api/studentreferrals/centers/${admissionId}/${municipalityId}/${locationTypeId}`
  );
};

export const getAdmissionMunicipalities = (admissionId, locationTypeId) => {
  return apiMipe.get(
    `api/studentreferrals/municipalities/${admissionId}/${locationTypeId}`
  );
};

export const getAdmissionRegions = (admissionId, locationTypeId) => {
  return apiMipe.get(
    `api/studentreferrals/regions/${admissionId}/${locationTypeId}`
  );
};

export const getAdmissionDistricts = (
  admissionId,
  regionId,
  locationTypeId
) => {
  return apiMipe.get(
    `api/studentreferrals/districts/${admissionId}/${regionId}/${locationTypeId}`
  );
};

export const getAdmissionSchools = (
  admissionId,
  districtId,
  locationTypeId
) => {
  return apiMipe.get(
    `api/studentreferrals/schools/${admissionId}/${districtId}/${locationTypeId}`
  );
};

export const getAbsenceReason = () =>
  apiMipe.get(`api/thrpyadmission/absencereason`);

export const addAbsence = (admissionId, params) =>
  apiMipe.post(`api/thrpyadmission/${admissionId}/absence`, params);

export const getStudentReferralAdmision = (admissionId) =>
  apiMipe.get(`api/studentreferrals/studentrefferaladmission/${admissionId}`);

export const getAdmissionNote = (admissionId) =>
  apiMipe.get(`api/thrpyadmission/${admissionId}/note`);

export const addAdmissionNote = (admissionId, params) =>
  apiMipe.post(`api/thrpyadmission/${admissionId}/note`, params);

export const getAdmissionManagementDocuments = () =>
  apiMipe.get(`api/thrpyadmission/admissionmanagement/documents`);

export const admissiontransfer = (management) => {
  return apiMipe.post(`api/thrpyadmission/adminissiontransfer`, management);
};
export const getSaeeSri06Report = (payload) => {
  return api.post(`api/report/saeesri06report`, payload);
};
export const getAllAdmissionNote = (admissionId) => {
  return apiMipe.get(`api/thrpyadmission/getallnoteadmission/${admissionId}`);
};
export const getSingleAdmissionNote = (noteId) => {
  return apiMipe.get(`api/thrpyadmission/noteadmission/${noteId}`);
};

export const getRecord = (studentServiceId) => {
  return apiMipe.get(`api/studentreferrals/${studentServiceId}/record`);
};

export const saveAdmissionNoteMechanism = (
  admissionId,
  isElectronicSignature
) =>
  apiMipe.put(
    `api/thrpyadmission/admissionnotemechanism/${admissionId}/${isElectronicSignature}`
  );

export const getAcademicYearWithDocuments = (studentSieId) => {
  return apiMipe.get(
    `api/studentreferrals/${studentSieId}/disciplines/academicYears-with-documents`
  );
};

export const getRecordDisciplines = (studentSieId, academicYearId) => {
  return apiMipe.get(
    `api/studentreferrals/${studentSieId}/${academicYearId}/disciplines`
  );
};

export const getRecordDisciplineDocumentTypes = (
  studentSieId,
  academicYearId,
  disciplineTypeId
) => {
  return apiMipe.get(
    `api/studentreferrals/${studentSieId}/${academicYearId}/disciplines/${disciplineTypeId}/documentTypes`
  );
};

export const getRecordDisciplineDocuments = (studentSieId, params) => {
  return apiMipe.get(
    `api/studentreferrals/${studentSieId}/disciplines/documents`,
    {
      params,
    }
  );
};

export const getRecordEvaluationFilterOptions = (studentSieId) => {
  return apiMipe.get(
    `api/studentreferrals/record/${studentSieId}/evaluation/filteroptions`
  );
};

export const getRecordEvaluation = (studentSieId, params) => {
  return apiMipe.get(`api/studentreferrals/record/${studentSieId}/evaluation`, {
    params,
  });
};

export const getRecordHistoryFilterOptions = (studentSieId) => {
  return apiMipe.get(
    `api/studentreferrals/record/${studentSieId}/history/filteroptions`
  );
};

export const getRecordEvaluationDetail = (evaluationId) => {
  return apiMipe.get(
    `api/studentreferrals/record/${evaluationId}/evaluation/detail`
  );
};

export const getStudentPeiHistory = (params) => {
  return apiMipe.get(`/api/studentreferrals/record/gethistory`, { params });
};

export const canCoordinateService = async (admisionid) => {
  return await apiMipe.get(
    `api/studentreferrals/cancoordinateservice/${admisionid}`
  );
};

export const getInterventionPlanAvailableServiceAreas = (
  studentSieId,
  academicYearId,
  peiId = null
) => {
  return apiMipe.get(
    `api/studentreferrals/interventionplanavailableserviceareas`,
    {
      params: {
        studentSieId,
        academicYearId,
        ...(peiId && { peiId }),
      },
    }
  );
};

export const getInterventionPlanAvailableGoals = (
  studentSieId,
  academicYearId,
  peiId = null
) => {
  return apiMipe.get(`api/studentreferrals/interventionplanavailablegoals`, {
    params: {
      studentSieId,
      academicYearId,
      ...(peiId && { peiId }),
    },
  });
};
